// src/wagmi.ts
import { connectorsForWallets } from '@rainbow-me/rainbowkit';
import {
  coinbaseWallet,
  injectedWallet,
  metaMaskWallet,
  rainbowWallet,
  walletConnectWallet,
} from '@rainbow-me/rainbowkit/wallets';
import { createConfig } from 'wagmi';
import { createBaseFallbackTransport, baseChainWithFallbackTransport } from '../lib/baseRpc';
import { farcasterMiniAppConnector } from './farcasterConnector';

const walletConnectProjectId =
  import.meta.env.VITE_WALLETCONNECT_PROJECT_ID?.trim() || '89a60473dcbe5b1247f7d1783d9e4cf8';

const rkConnectors = connectorsForWallets(
  [
    {
      groupName: 'Suggested',
      wallets: [injectedWallet, metaMaskWallet, rainbowWallet, coinbaseWallet, walletConnectWallet],
    },
  ],
  { appName: 'takni.xyz', projectId: walletConnectProjectId },
);

export const config = createConfig({
  chains: [baseChainWithFallbackTransport],
  connectors: [farcasterMiniAppConnector(), ...rkConnectors],
  transports: {
    [baseChainWithFallbackTransport.id]: createBaseFallbackTransport(),
  },
  ssr: false,
});
